import type * as schemas from "@common/schemas/v2";
import * as models from "@common/models/v2";
import { BaseStep } from "./base";
import { StepActions } from "./step";
import { getCurrentPath, navigateToPath } from "@/lib/window";
import { FlowFlexibility } from "@common/schemas";

export class RedirectStep extends BaseStep {
  attributes: models.RedirectStepAttributes;
  actions: StepActions;

  constructor(step: schemas.Step, actions: StepActions, flowFlexibility: FlowFlexibility) {
    super(step, actions, flowFlexibility);
    this.attributes = new models.RedirectStepAttributes(step.attributes as schemas.RedirectStepAttributes);
    this.actions = actions;
  }

  async run() {
    super.run();
    if (this.attributes.slug && this.attributes.changeType === "redirect") {
      // Mark this step as completed BEFORE navigation to prevent infinite loops
      // when the page reloads and the widget restarts
      this.markAsCompletedBeforeNavigation();
      this.switchByRoute(this.attributes.slug);
    }
  }

  private markAsCompletedBeforeNavigation() {
    // Trigger early completion for navigation steps to prevent infinite loops
    // This ensures lastCompletedStepId is set before the page navigates away
    this.events.emit("earlyCompletionForNavigation", { stepId: this.id });
  }

  private switchByRoute(path: string) {
    const currentPath = getCurrentPath();
    const newRoute = this.parseRoutePattern(path);

    if (newRoute !== currentPath) {
      navigateToPath(newRoute);
    }
  }

  private parseRoutePattern = (path: string) => {
    const currentPath = getCurrentPath();
    const currentRoutes = currentPath.split("/");

    return path
      .split("/")
      .map((r, index) => (r === "*" ? currentRoutes[index] : r))
      .join("/");
  };

  get isBlockingStepType() {
    return false;
  }

  // TODO: discuss the risk of trusting on the execution of the last step before reload with Ashish
  get isBlocking() {
    return false;
  }
}
